module.exports = __webpack_public_path__ + "static/media/mail.1f346261.svg";